import { Period } from '@js-joda/core';

import {
   CurrentDocplannerHealthcareProviderConfigurationCreateCommand,
   CurrentDocplannerHealthcareProviderConfigurationQuery,
   DocplannerAuthenticationFault,
   DocplannerHealthcareProviderConfiguration,
} from '@dreryk/egabinet-docplanner-frontend-api';

import {
   useCqrsCommand,
   UseCqrsCommandResult,
   useCqrsFind,
   UseCqrsQueryResult,
} from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { integrationTranslationKeys } from '../translations';

import { DocplannerIntegrationFormBean } from './integration.types';

export const useDocplannerIntegrationConfigurationQuery = (): UseCqrsQueryResult<DocplannerHealthcareProviderConfiguration | null> => {
   return useCqrsFind(() => new CurrentDocplannerHealthcareProviderConfigurationQuery());
};

export const useCurrentDocplannerConfigurationCreateCommand = (
   onDocplannerAuthenticationFault: VoidFunction,
   onSuccess: (newDocplannerConfiguration: DocplannerHealthcareProviderConfiguration) => void
): UseCqrsCommandResult<DocplannerHealthcareProviderConfiguration, DocplannerIntegrationFormBean> => {
   return useCqrsCommand<
      DocplannerHealthcareProviderConfiguration,
      DocplannerIntegrationFormBean,
      DocplannerAuthenticationFault
   >(
      (parameters) => {
         const command = new CurrentDocplannerHealthcareProviderConfigurationCreateCommand();
         command.clientId = parameters.apiKey!;
         command.clientSecret = parameters.apiSecret!;
         command.slotSynchronizationDuration = Period.ofDays(parameters.synchronizationDaysCount!);
         return command;
      },
      {
         onSuccess: (newDocplannerConfiguration) => {
            dispatchSnackbarPositiveEvent(integrationTranslationKeys.docplannerConfigurationFetchSuccess);
            onSuccess(newDocplannerConfiguration);
         },
         onFault: {
            'egabinet-docplanner-frontend-api:DocplannerAuthenticationFault': onDocplannerAuthenticationFault,
         },
      }
   );
};
